// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* footer.css Datei */
/* Stil für das DogFriendly-Bild */
.app__footer_icons img {
  width: 5rem;  
  height: 5rem;
  object-fit: cover; 
}

/* Zentrierung der Icons und Bilder */
.app__footer_section {
  text-align: center; 
  min-width: 350px; 
}

.footer-icon, .app__footer_icons img {
  transition: transform 0.3s ease;
}

.footer-icon:hover, .app__footer_icons img:hover {
  transform: scale(1.1);
}


.app__footer_container {
  display: flex;
  justify-content: center;
  justify-content: space-evenly;
  align-items: center;
  padding: 50px;
}

.app__footer_section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.app__footer_container_heading {
  font-size: 3.5rem;
  font-family: "SawtonIndustrial-Bold";
  margin-bottom: 10px;
  color: var(--color-white);
}

.app__footer_icons {
  display: flex;
  gap: 20px;
}

.footer-icon {
  font-size: 5rem;
  color: var(--color-white);
}

@media screen and (max-width: 1200px) {
  .app__footer_container_heading {
    font-size: 3rem;
  }

  .footer-icon {
    font-size: 4rem;
  }
  .app__footer_icons img {
    width: 4rem;  
    height: 4rem;
  }
  .app__footer_section {
    min-width: 300px; 
  }
}
@media (max-width: 1020px) {
  .app__footer_container {
    flex-direction: column;
    align-items: center;
    padding: 20px 10px;
  }

  .app__footer_section {
    margin-bottom: 20px;
  }

  .app__footer_icons {
    gap: 15px;
  }
}
@media (max-width: 450px) {
  .app__footer_container_heading {
    font-size: 2rem;
  }

  .footer-icon {
    font-size: 3rem;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/footer.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* footer.css Datei */\n/* Stil für das DogFriendly-Bild */\n.app__footer_icons img {\n  width: 5rem;  \n  height: 5rem;\n  object-fit: cover; \n}\n\n/* Zentrierung der Icons und Bilder */\n.app__footer_section {\n  text-align: center; \n  min-width: 350px; \n}\n\n.footer-icon, .app__footer_icons img {\n  transition: transform 0.3s ease;\n}\n\n.footer-icon:hover, .app__footer_icons img:hover {\n  transform: scale(1.1);\n}\n\n\n.app__footer_container {\n  display: flex;\n  justify-content: center;\n  justify-content: space-evenly;\n  align-items: center;\n  padding: 50px;\n}\n\n.app__footer_section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.app__footer_container_heading {\n  font-size: 3.5rem;\n  font-family: \"SawtonIndustrial-Bold\";\n  margin-bottom: 10px;\n  color: var(--color-white);\n}\n\n.app__footer_icons {\n  display: flex;\n  gap: 20px;\n}\n\n.footer-icon {\n  font-size: 5rem;\n  color: var(--color-white);\n}\n\n@media screen and (max-width: 1200px) {\n  .app__footer_container_heading {\n    font-size: 3rem;\n  }\n\n  .footer-icon {\n    font-size: 4rem;\n  }\n  .app__footer_icons img {\n    width: 4rem;  \n    height: 4rem;\n  }\n  .app__footer_section {\n    min-width: 300px; \n  }\n}\n@media (max-width: 1020px) {\n  .app__footer_container {\n    flex-direction: column;\n    align-items: center;\n    padding: 20px 10px;\n  }\n\n  .app__footer_section {\n    margin-bottom: 20px;\n  }\n\n  .app__footer_icons {\n    gap: 15px;\n  }\n}\n@media (max-width: 450px) {\n  .app__footer_container_heading {\n    font-size: 2rem;\n  }\n\n  .footer-icon {\n    font-size: 3rem;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
